module.exports = __webpack_public_path__ + "static/media/dashboard-logo.81a75cfb.png";